import { render, staticRenderFns } from "./capitalturn-record.vue?vue&type=template&id=2dcaf442&scoped=true&"
import script from "./capitalturn-record.vue?vue&type=script&lang=js&"
export * from "./capitalturn-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcaf442",
  null
  
)

export default component.exports